import * as T from 'io-ts';
import { LuxonDateTimeT } from '../../SpecificCodecs/LuxonDateTime';
const LobbyStatusT = T.keyof({
    Open: null,
    Closed: null,
    Full: null,
});
export const LobbyStateT = T.type({
    status: LobbyStatusT,
    updatedAt: LuxonDateTimeT,
}, 'LobbyState');
